module.exports = __webpack_public_path__ + "static/brain-sad-75693d8e1b841668c41373c3a7da4ca1.png";